require('./contact.scss');

import DemandeActions from '../../../../actions/demande.actions';

import { CIVILITE } from '../../../base/model';
import { STEPS } from '../../../../utils/routes.util';
import { EMAIL_PATTERN, TELEPHONE_PATTERN } from '../../../../utils/pattern.util';

export default class ContactComponent {
  constructor() {
    this.controller = ContactController;
    this.template = require('./contact.html');
  }
}

// @ngInject
class ContactController {

  constructor($scope, $ngRedux) {
    this.CIVILITE = CIVILITE;
    this.regex = new RegExp(/^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/, 'u');
    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.emailPattern = EMAIL_PATTERN;
    this.telephonePattern = TELEPHONE_PATTERN;
  }

  $onInit() {
    // Demande de récupération de la demande avant connexion au state
    this.$ngRedux.dispatch(DemandeActions.loadDemande(STEPS.CONTACT));

    // Connexion au state récupérer les données modifiées
    const disconnect = this.$ngRedux.connect(
      state => {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          data: state.demande.data.contact ? state.demande.data.contact.asMutable({deep: true}) : this.data,
          messagePerturbation: state.demande.data.zonePerturbe ? state.demande.data.zonePerturbe.message : null
        };
      }
    )(this);
    this.data = {civilite: CIVILITE.DEFAULT_VALUE};
    // Déconnexion du state à la suppression du composant
    this.$scope.$on('$destroy', disconnect);
  }

  onComplementAdresseChange(complementAdresse) {
    this.data.complementAdresse = complementAdresse;
  }
  onAdresseChange(adresse) {
    this.data.adresse = adresse;
  }
  // Actions
  prevStep() {
    this.$ngRedux.dispatch(DemandeActions.updateContact(this.data, true));
  }
  nextStep() {
    this.$ngRedux.dispatch(DemandeActions.updateContact(this.data));
  }
}



// WEBPACK FOOTER //
// ./src/modules/antenniste/components/contact/contact.component.js